import { combineReducers } from "redux";
import * as actions from "../actions";

export const REPORT_BASIS = [
  { label: "결제일 기준", value: "pay" },
  { label: "영업일 기준", value: "sales" },
];

const initialState = {
  salesStatus: {
    isFetching: false,
    error: null,
  },
  sales: {
    products: {},
    sideMenu: {},
    timeSale: {},
    categories: {},
    modifiers: {},
    daySale: {},
    discountSale: {},
    order: {},
    summary: {},
    summaryCompare: {},
  },
  items: {},
  itemsStatus: {
    isFetching: false,
    error: null,
  },
  dailyStatus: {
    isFetching: false,
    error: null,
  },
  daily: [],
  orderStatus: {
    isFetching: false,
    error: null,
  },
  order: {},
  customer: {},
  customerVisitStatus: {
    isFetching: false,
    error: null,
  },
  customerVisit: {},
  customerSalesStatus: {
    isFetching: false,
    error: null,
  },
  customerSales: {},
  customerSummaryStatus: {
    isFetching: false,
    error: null,
  },
  customerSummary: {},
  customerDemographicStatus: {
    isFetching: false,
    error: null,
  },
  customerDemographic: {},
  itemsDemographicStatus: {
    isFetching: false,
    error: null,
  },
  itemsDemographic: {},
  channelStatus: {
    isFetching: false,
    error: null,
  },
  channel: {},
  pointStatus: {
    isFetching: false,
    error: null,
  },
  point: {},
  deliveryStatus: {
    isFetching: false,
    error: null,
  },
  delivery: {},
  storeList: {}, // 리포트 v2 게이트④ 전용 (스위치 off 면 비어 있음)
  product: {}, // 리포트 v2 제품 봉투 (스위치 off 면 비어 있음)
  // 🔴 v1 할인 리포트가 이미 report.discount 를 쓴다 — 같은 슬롯에 봉투를 넣으면 서로 덮는다
  discountV2: {}, // 리포트 v2 할인 봉투 (스위치 off 면 비어 있음)
  customerV2: {}, // 리포트 v2 고객 봉투 (스위치 off 면 비어 있음)
  membershipV2: {}, // 리포트 v2 멤버십 봉투 (스위치 off 면 비어 있음)
  storeMemos: [], // 매장 메모 (Notice type='hq-note') — 조회 전용
  trs: {},
  trsItem: {},
  subscription: {},
  subscriptionStatus: {
    isFetching: false,
    error: null,
  },
  loyaltyStatus: {
    isFetching: false,
    error: null,
  },
  loyalty: {},
  inventoryStatus: {
    isFetching: false,
    error: null,
  },
  inventory: {},
  membershipReport: {},
  membershipStatus: {
    isFetching: false,
    error: null,
  },
  discount: {},
  discountStatus: {
    isFetching: false,
    error: null,
  },
  discountTopProducts: {},
  discountTopProductsStatus: {
    isFetching: false,
    error: null,
  },
};

function salesStatus(state = initialState.salesStatus, action) {
  switch (action.type) {
    case actions.GET_SALES_REPORT:
      return {
        isFetching: true,
        error: null,
      };
    case actions.GET_SALES_REPORT_SUCCESS:
      return initialState.salesStatus;
    case actions.GET_SALES_REPORT_FAILURE:
      return {
        isFetching: false,
        error: action.error,
      };
    default:
      return state;
  }
}

const sales = (state = initialState.sales, action) => {
  switch (action.type) {
    case actions.RECEIVE_SALES_REPORT:
      return {
        ...state,
        [action.report.item.type]: action.report.item,
      };
    case actions.SIGN_OUT:
      return initialState.sales;
    default:
      return state;
  }
};

const items = (state = initialState.items, action) => {
  switch (action.type) {
    case actions.RECEIVE_ITEMS_REPORT:
      return action.report;
    case actions.SIGN_OUT:
      return initialState.order;
    default:
      return state;
  }
};

function itemsStatus(state = initialState.itemsStatus, action) {
  switch (action.type) {
    case actions.GET_ITEMS_REPORT:
      return {
        isFetching: true,
        error: null,
      };
    case actions.SET_ITEMS_REPORT_SUCCESS:
      return initialState.itemsStatus;
    case actions.SET_ITEMS_REPORT_FAILURE:
      return {
        isFetching: false,
        error: action.error,
      };
    default:
      return state;
  }
}

function dailyStatus(state = initialState.dailyStatus, action) {
  switch (action.type) {
    case actions.GET_SALES_HISTORIES:
      return {
        isFetching: true,
        error: null,
      };
    case actions.GET_SALES_HISTORIES_SUCCESS:
      return initialState.dailyStatus;
    case actions.GET_SALES_HISTORIES_FAILURE:
      return {
        isFetching: false,
        error: action.error,
      };
    default:
      return state;
  }
}

const daily = (state = initialState.daily, action) => {
  switch (action.type) {
    case actions.RECEIVE_SALES_HISTORIES:
      return action.histories;
    default:
      return state;
  }
};

function orderStatus(state = initialState.orderStatus, action) {
  switch (action.type) {
    case actions.GET_ORDER_REPORT:
      // 🔴 섹션 재시도는 전역 로딩을 켜지 않는다 [S-64 ③ · 우진 QA 2026-08-14].
      //    켜면 탭 전체가 스켈레톤/오버레이로 덮여 "전체를 다시 조회한다"로 읽힌다.
      //    그 섹션 자리 스피너는 pendingSections 가 담당한다.
      if (action.options?.__sectionRetry) return state;
      return {
        isFetching: true,
        error: null,
      };
    case actions.GET_ORDER_REPORT_SUCCESS:
      return initialState.orderStatus;
    case actions.GET_ORDER_REPORT_FAILURE:
      return {
        isFetching: false,
        error: action.error,
      };
    default:
      return state;
  }
}

const order = (state = initialState.order, action) => {
  switch (action.type) {
    case actions.RECEIVE_ORDER_REPORT:
      return action.report;
    case actions.SIGN_OUT:
      return initialState.order;
    default:
      return state;
  }
};

const customer = (state = initialState.customer, action) => {
  switch (action.type) {
    case actions.RECEIVE_CUSTOMER_REPORT:
      return action.report;
    case actions.SIGN_OUT:
      return initialState.customer;
    default:
      return state;
  }
};

function customerVisitStatus(
  state = initialState.customerVisitStatus,
  action,
) {
  switch (action.type) {
    case actions.GET_CUSTOMER_VISIT_REPORT:
      return { isFetching: true, error: null };
    case actions.GET_CUSTOMER_VISIT_REPORT_SUCCESS:
      return initialState.customerVisitStatus;
    case actions.GET_CUSTOMER_VISIT_REPORT_FAILURE:
      return { isFetching: false, error: action.error };
    default:
      return state;
  }
}

const customerVisit = (state = initialState.customerVisit, action) => {
  switch (action.type) {
    case actions.RECEIVE_CUSTOMER_VISIT_REPORT:
      return action.report;
    case actions.SIGN_OUT:
      return initialState.customerVisit;
    default:
      return state;
  }
};

function customerSalesStatus(
  state = initialState.customerSalesStatus,
  action,
) {
  switch (action.type) {
    case actions.GET_CUSTOMER_SALES_REPORT:
      return { isFetching: true, error: null };
    case actions.GET_CUSTOMER_SALES_REPORT_SUCCESS:
      return initialState.customerSalesStatus;
    case actions.GET_CUSTOMER_SALES_REPORT_FAILURE:
      return { isFetching: false, error: action.error };
    default:
      return state;
  }
}

const customerSales = (state = initialState.customerSales, action) => {
  switch (action.type) {
    case actions.RECEIVE_CUSTOMER_SALES_REPORT:
      return action.report;
    case actions.SIGN_OUT:
      return initialState.customerSales;
    default:
      return state;
  }
};

function customerSummaryStatus(
  state = initialState.customerSummaryStatus,
  action,
) {
  switch (action.type) {
    case actions.GET_CUSTOMER_SUMMARY:
      return { isFetching: true, error: null };
    case actions.GET_CUSTOMER_SUMMARY_SUCCESS:
      return initialState.customerSummaryStatus;
    case actions.GET_CUSTOMER_SUMMARY_FAILURE:
      return { isFetching: false, error: action.error };
    default:
      return state;
  }
}

const customerSummary = (state = initialState.customerSummary, action) => {
  switch (action.type) {
    case actions.RECEIVE_CUSTOMER_SUMMARY:
      return action.report;
    case actions.SIGN_OUT:
      return initialState.customerSummary;
    default:
      return state;
  }
};

function customerDemographicStatus(
  state = initialState.customerDemographicStatus,
  action,
) {
  switch (action.type) {
    case actions.GET_CUSTOMER_DEMOGRAPHIC_REPORT:
      return { isFetching: true, error: null };
    case actions.GET_CUSTOMER_DEMOGRAPHIC_REPORT_SUCCESS:
      return initialState.customerDemographicStatus;
    case actions.GET_CUSTOMER_DEMOGRAPHIC_REPORT_FAILURE:
      return { isFetching: false, error: action.error };
    default:
      return state;
  }
}

const customerDemographic = (
  state = initialState.customerDemographic,
  action,
) => {
  switch (action.type) {
    case actions.RECEIVE_CUSTOMER_DEMOGRAPHIC_REPORT:
      return action.report;
    case actions.SIGN_OUT:
      return initialState.customerDemographic;
    default:
      return state;
  }
};

function itemsDemographicStatus(
  state = initialState.itemsDemographicStatus,
  action,
) {
  switch (action.type) {
    case actions.GET_ITEMS_DEMOGRAPHIC_REPORT:
      return { isFetching: true, error: null };
    case actions.GET_ITEMS_DEMOGRAPHIC_REPORT_SUCCESS:
      return initialState.itemsDemographicStatus;
    case actions.GET_ITEMS_DEMOGRAPHIC_REPORT_FAILURE:
      return { isFetching: false, error: action.error };
    default:
      return state;
  }
}

const itemsDemographic = (state = initialState.itemsDemographic, action) => {
  switch (action.type) {
    case actions.RECEIVE_ITEMS_DEMOGRAPHIC_REPORT:
      return action.report;
    case actions.SIGN_OUT:
      return initialState.itemsDemographic;
    default:
      return state;
  }
};

function pointStatus(state = initialState.pointStatus, action) {
  switch (action.type) {
    case actions.GET_POINT_REPORT:
      return {
        isFetching: true,
        error: null,
      };
    case actions.GET_POINT_REPORT_SUCCESS:
      return initialState.pointStatus;
    case actions.GET_POINT_REPORT_FAILURE:
      return {
        isFetching: false,
        error: action.error,
      };
    default:
      return state;
  }
}

const point = (state = initialState.point, action) => {
  switch (action.type) {
    case actions.RECEIVE_POINT_REPORT:
      return action.report;
    case actions.SIGN_OUT:
      return initialState.point;
    default:
      return state;
  }
};

function deliveryStatus(state = initialState.deliveryStatus, action) {
  switch (action.type) {
    case actions.GET_DELIVERY_REPORT:
      return {
        isFetching: true,
        error: null,
      };
    case actions.GET_DELIVERY_REPORT_SUCCESS:
      return initialState.deliveryStatus;
    case actions.GET_DELIVERY_REPORT_FAILURE:
      return {
        isFetching: false,
        error: action.error,
      };
    default:
      return state;
  }
}

const delivery = (state = initialState.delivery, action) => {
  switch (action.type) {
    case actions.RECEIVE_DELIVERY_REPORT:
      return action.report;
    case actions.SIGN_OUT:
      return initialState.delivery;
    default:
      return state;
  }
};

const storeList = (state = initialState.storeList, action) => {
  switch (action.type) {
    case actions.RECEIVE_STORE_LIST_REPORT:
      return action.report;
    case actions.SIGN_OUT:
      return initialState.storeList;
    default:
      return state;
  }
};

const product = (state = initialState.product, action) => {
  switch (action.type) {
    case actions.RECEIVE_PRODUCT_REPORT:
      return receiveEnvelope(state, action.report);
    case actions.MERGE_REPORT_SECTIONS:
      return action.item === "product" ? mergeSections(state, action) : state;
    case actions.GET_ORDER_REPORT:
      // 섹션 재시도 시작 → 그 섹션만 로딩으로 (전역 로딩은 안 켠다)
      return action.item === "product" && action.options?.__sectionRetry
        ? markSectionsPending(state, action.options.sections)
        : state;
    case actions.SIGN_OUT:
      return initialState.product;
    default:
      return state;
  }
};


// 리포트 봉투 수신 — **더 낡은 응답은 무시**한다(조회가 겹치면 도착 순서가 뒤집힌다).
const receiveEnvelope = (state, report) => {
  const prev = state?.__seq;
  const next = report?.__seq;
  if (prev != null && next != null && next < prev) return state;
  return report;
};

// ── S-40 분리 로딩 병합 ────────────────────────────────────────────────
// 🔴 2차 봉투를 통째로 갈아끼우면 1차 섹션이 사라진다 — data 만 얹는다.
//    실패 시에는 서버가 쓰는 것과 같은 형태의 warning(SECTION_FAILED)을 넣어
//    화면이 「조회 실패」로 그리게 한다(부재로 뭉개지 않는다).
// 섹션 재시도 시작 — 그 섹션을 **대기(pending)** 로 되돌린다.
// 🔴 전역 로딩을 안 켜는 대신(S-64 ③) 그 자리에 스피너가 돌아야 한다.
//    실패 문구를 그대로 두면 눌러도 아무 반응이 없는 것으로 보인다.
const markSectionsPending = (state, sections) => {
  if (!state || !sections?.length) return state;
  return {
    ...state,
    pendingSections: [
      ...new Set([...(state.pendingSections || []), ...sections]),
    ],
    // 재시도 중에는 이전 실패 표시를 걷는다 (성공하면 그대로, 실패하면 다시 붙는다)
    warnings: (state.warnings || [])
      .map((w) => {
        if (w?.code !== "SECTION_FAILED" && w?.code !== "SECTIONS_TIMEOUT") return w;
        const rest = (w.detail?.sections || []).filter((k) => !sections.includes(k));
        return rest.length ? { ...w, detail: { ...w.detail, sections: rest } } : null;
      })
      .filter(Boolean),
  };
};

const mergeSections = (state, action) => {
  if (!state) return state;
  const { report, sections = [], failed, seq } = action;
  // 🔴 순번 모델 [우진 QA 2026-08-14 재정리 — 지점/전체지점 혼합 + 1페이지 사고]:
  //    __seq = **논리 조회**(기간·스코프)의 순번. 1차 봉투가 정하고, 병합은 올리지
  //    않는다. 표 페이지 넘김·S-40 2차는 같은 논리 조회의 하위 요청이다.
  //  · 옛 논리 조회의 잔여 응답(seq < __seq) → 폐기 (지점 2차가 전체지점을 덮던 건)
  //  · 표 병합끼리는 __tableSeq 로 최신만 수용 (페이지 연타 시 옛 페이지 차단)
  //  · S-40 2차(seq == __seq)는 표 병합 뒤에 도착해도 정상 수용 — 다른 섹션이다
  if (seq != null && state.__seq != null && seq < state.__seq) {
    return state;
  }
  const touchesTable = sections.includes("table");
  if (
    touchesTable &&
    seq != null &&
    state.__tableSeq != null &&
    seq < state.__tableSeq
  ) {
    return state;
  }
  // 도착(또는 실패)한 섹션만 대기 목록에서 지운다 — 표 병합이 timeTop 대기를
  // 지우면 2차가 오기 전까지 「데이터 없음」으로 보인다
  const restPending = (state.pendingSections || []).filter(
    (k) => !sections.includes(k),
  );
  // 🔴 이번 병합이 담당한 섹션의 **낡은 실패 경고를 걷어낸다** [S-49 재시도].
  //    안 걷으면 ① 재시도가 성공해도 화면이 계속 「실패」로 남고 ② 실패가 반복되면
  //    같은 경고가 중복 적재된다. 경고 하나가 여러 섹션을 덮을 수 있으므로(2차 실패
  //    = deferred 5종 묶음) 통째로 지우지 않고 **이번 섹션만 차감**한다.
  const subtractStale = (list) =>
    (list || [])
      .map((w) => {
        if (w?.code !== "SECTION_FAILED" && w?.code !== "SECTIONS_TIMEOUT") return w;
        const covered = w.detail?.sections || [];
        if (!covered.some((k) => sections.includes(k))) return w;
        const rest = covered.filter((k) => !sections.includes(k));
        return rest.length ? { ...w, detail: { ...w.detail, sections: rest } } : null;
      })
      .filter(Boolean);
  if (failed || !report) {
    return {
      ...state,
      warnings: [
        ...subtractStale(state.warnings),
        {
          code: "SECTION_FAILED",
          message: "일부 섹션을 불러오지 못했습니다",
          detail: { sections },
        },
      ],
      pendingSections: restPending,
    };
  }
  return {
    ...state,
    data: { ...(state.data || {}), ...(report.data || {}) },
    // 🔴 meta 는 **table 이 실려 온 병합에서만** 갱신한다 [1페이지 사고의 실원인].
    //    S-40 2차(timeTop 등)는 data 에 table 이 없어 서버가 meta.page=None 을
    //    내린다(report_v2.py: `if "table" in data else None`) — 그 meta 로 덮으면
    //    표 페이지 정보가 지워져 total 이 rows.length(10)로 폴백, 1페이지가 된다.
    meta: touchesTable && report.meta ? report.meta : state.meta,
    warnings: [...subtractStale(state.warnings), ...(report.warnings || [])],
    pendingSections: restPending,
    ...(touchesTable && seq != null ? { __tableSeq: seq } : {}),
  };
};

const discountV2 = (state = initialState.discountV2, action) => {
  switch (action.type) {
    case actions.RECEIVE_DISCOUNT_V2_REPORT:
      return receiveEnvelope(state, action.report);
    case actions.MERGE_REPORT_SECTIONS:
      return action.item === "discount" ? mergeSections(state, action) : state;
    case actions.GET_ORDER_REPORT:
      // 섹션 재시도 시작 → 그 섹션만 로딩으로 (전역 로딩은 안 켠다)
      return action.item === "discount" && action.options?.__sectionRetry
        ? markSectionsPending(state, action.options.sections)
        : state;
    case actions.SIGN_OUT:
      return initialState.discountV2;
    default:
      return state;
  }
};

const customerV2 = (state = initialState.customerV2, action) => {
  switch (action.type) {
    case actions.RECEIVE_CUSTOMER_V2_REPORT:
      return receiveEnvelope(state, action.report);
    case actions.MERGE_REPORT_SECTIONS:
      return action.item === "customer" ? mergeSections(state, action) : state;
    case actions.GET_ORDER_REPORT:
      // 섹션 재시도 시작 → 그 섹션만 로딩으로 (전역 로딩은 안 켠다)
      return action.item === "customer" && action.options?.__sectionRetry
        ? markSectionsPending(state, action.options.sections)
        : state;
    case actions.SIGN_OUT:
      return initialState.customerV2;
    default:
      return state;
  }
};

const storeMemos = (state = initialState.storeMemos, action) => {
  switch (action.type) {
    case actions.RECEIVE_STORE_MEMOS:
      return action.memos;
    case actions.SIGN_OUT:
      return initialState.storeMemos;
    default:
      return state;
  }
};

const membershipV2 = (state = initialState.membershipV2, action) => {
  switch (action.type) {
    case actions.RECEIVE_MEMBERSHIP_V2_REPORT:
      return action.report;
    case actions.SIGN_OUT:
      return initialState.membershipV2;
    default:
      return state;
  }
};

const trs = (state = initialState.trs, action) => {
  switch (action.type) {
    case actions.RECEIVE_TRS_REPORT:
      return action.report;
    case actions.SIGN_OUT:
      return initialState.trs;
    default:
      return state;
  }
};

const trsItem = (state = initialState.trsItem, action) => {
  switch (action.type) {
    case actions.RECEIVE_TRS_ITEM_REPORT:
      return action.report;
    case actions.SIGN_OUT:
      return initialState.trs;
    default:
      return state;
  }
};

const subscription = (state = initialState.subscription, action) => {
  switch (action.type) {
    case actions.RECEIVE_SUBSCRIPTION_REPORT:
      return action.report;
    case actions.SIGN_OUT:
      return initialState.subscription;
    default:
      return state;
  }
};

function subscriptionStatus(state = initialState.subscriptionStatus, action) {
  switch (action.type) {
    case actions.GET_SUBSCRIPTION_REPORT:
      return {
        isFetching: true,
        error: null,
      };
    case actions.SET_SUBSCRIPTION_REPORT_SUCCESS:
      return initialState.subscriptionStatus;
    case actions.SET_SUBSCRIPTION_REPORT_FAILURE:
      return {
        isFetching: false,
        error: action.error,
      };
    default:
      return state;
  }
}

function loyaltyStatus(state = initialState.loyaltyStatus, action) {
  switch (action.type) {
    case actions.GET_LOYALTY_REPORT1:
      return {
        isFetching: true,
        error: null,
      };
    case actions.GET_LOYALTY_REPORT1_SUCCESS:
      return initialState.loyaltyStatus;
    case actions.GET_LOYALTY_REPORT1_FAILURE:
      return {
        isFetching: false,
        error: action.error,
      };
    default:
      return state;
  }
}

const loyalty = (state = initialState.loyalty, action) => {
  switch (action.type) {
    case actions.RECEIVE_LOYALTY_REPORT1:
      return action.report;
    case actions.SIGN_OUT:
      return initialState.loyalty;
    default:
      return state;
  }
};

function inventoryStatus(state = initialState.inventoryStatus, action) {
  switch (action.type) {
    case actions.GET_INVENTORY_DATE_REPORT:
    case actions.GET_INVENTORY_ITEM_REPORT:
    case actions.GET_INVENTORY_TURNOVER_REPORT:
    case actions.GET_INVENTORY_ASSET_REPORT:
      return {
        isFetching: true,
        error: null,
      };
    case actions.SET_INVENTORY_REPORT_STATUS_SUCCESS:
      return initialState.inventoryStatus;
    case actions.SET_INVENTORY_REPORT_STATUS_FAILURE:
      return {
        isFetching: false,
        error: action.error.errors[0]?.message,
      };
    default:
      return state;
  }
}

const inventory = (state = initialState.inventory, action) => {
  switch (action.type) {
    case actions.RECEIVE_INVENTORY_REPORT:
      return action.report;
    case actions.SIGN_OUT:
      return initialState.inventory;
    default:
      return state;
  }
};

const channel = (state = initialState.channel, action) => {
  switch (action.type) {
    case actions.RECEIVE_CHANNEL_ORDER_REPORT:
      return action.report;
    case actions.SIGN_OUT:
      return initialState.inventory;
    default:
      return state;
  }
};

function channelStatus(state = initialState.channelStatus, action) {
  switch (action.type) {
    case actions.GET_CHANNEL_ORDER_REPORT:
      return {
        isFetching: true,
        error: null,
      };
    case actions.SET_CHANNEL_ORDER_REPORT_SUCCESS:
      return initialState.orderStatus;
    case actions.SET_CHANNEL_ORDER_REPORT_FAILURE:
      return {
        isFetching: false,
        error: action.error,
      };
    default:
      return state;
  }
}

const membershipReport = (state = initialState.membershipReport, action) => {
  switch (action.type) {
    case actions.RECEIVE_MEMBERSHIP_REPORT:
      return action.report;
    case actions.SIGN_OUT:
      return initialState.membershipReport;
    default:
      return state;
  }
};

function membershipStatus(state = initialState.membershipStatus, action) {
  switch (action.type) {
    case actions.GET_MEMBERSHIP_REPORT:
      return {
        isFetching: true,
        error: null,
      };
    case actions.SET_MEMBERSHIP_REPORT_SUCCESS:
      return initialState.membershipStatus;
    case actions.SET_MEMBERSHIP_REPORT_FAILURE:
      return {
        isFetching: false,
        error: action.error,
      };
    default:
      return state;
  }
}

// 할인 리포트 v2 — discount summary/daily/breakdown/discountList
function discountStatus(state = initialState.discountStatus, action) {
  switch (action.type) {
    case actions.GET_DISCOUNT_REPORT:
      return { isFetching: true, error: null };
    case actions.GET_DISCOUNT_REPORT_SUCCESS:
      return initialState.discountStatus;
    case actions.GET_DISCOUNT_REPORT_FAILURE:
      return { isFetching: false, error: action.error };
    default:
      return state;
  }
}

const discount = (state = initialState.discount, action) => {
  switch (action.type) {
    case actions.RECEIVE_DISCOUNT_REPORT:
      return action.report;
    case actions.SIGN_OUT:
      return initialState.discount;
    default:
      return state;
  }
};

// 할인 리포트 v2 — 쿠폰 인기제품 TOP5
function discountTopProductsStatus(
  state = initialState.discountTopProductsStatus,
  action,
) {
  switch (action.type) {
    case actions.GET_DISCOUNT_TOP_PRODUCTS_REPORT:
      return { isFetching: true, error: null };
    case actions.GET_DISCOUNT_TOP_PRODUCTS_REPORT_SUCCESS:
      return initialState.discountTopProductsStatus;
    case actions.GET_DISCOUNT_TOP_PRODUCTS_REPORT_FAILURE:
      return { isFetching: false, error: action.error };
    default:
      return state;
  }
}

const discountTopProducts = (
  state = initialState.discountTopProducts,
  action,
) => {
  switch (action.type) {
    case actions.RECEIVE_DISCOUNT_TOP_PRODUCTS_REPORT:
      return action.report;
    case actions.SIGN_OUT:
      return initialState.discountTopProducts;
    default:
      return state;
  }
};

export default combineReducers({
  salesStatus,
  sales,
  dailyStatus,
  daily,
  orderStatus,
  order,
  customer,
  customerVisitStatus,
  customerVisit,
  customerSalesStatus,
  customerSales,
  customerSummaryStatus,
  customerSummary,
  customerDemographicStatus,
  customerDemographic,
  itemsDemographicStatus,
  itemsDemographic,
  pointStatus,
  point,
  deliveryStatus,
  delivery,
  storeList,
  product,
  discountV2,
  customerV2,
  membershipV2,
  storeMemos,
  trs,
  trsItem,
  loyaltyStatus,
  loyalty,
  subscriptionStatus,
  subscription,
  inventoryStatus,
  inventory,
  channel,
  channelStatus,
  items,
  itemsStatus,
  membershipReport,
  membershipStatus,
  discount,
  discountStatus,
  discountTopProducts,
  discountTopProductsStatus,
});
